import { useDisclosure } from '@chakra-ui/hooks';
import { CloseButton, Drawer, DrawerBody, DrawerContent, DrawerOverlay, Flex, IconButton } from '@chakra-ui/react';
import { FC } from 'react';

import FunnelIcon from '@/assets/icons/ic-funnel.svg';

import { EventSessionsDropdown } from '@/components/event/EventSessionsDropdown';
import { EventSearchInput } from '@/components/ui/features/events-list/EventSearchInput/EventSearchInput';
import {
  ScheduleTrackFilter,
  TrackFilterScope,
} from '@/components/ui/features/schedule/ScheduleTrackFilter/ScheduleTrackFilter';
import { SessionTagFilter } from '@/components/ui/features/session/SessionTagFilter/SessionTagFilter';
import { SearchCategories } from '@/enums';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';

export const PostersHeaderMobile: FC = () => {
  const { eventSessionId, trackIds, tagIds } = useQueryParams<{
    eventSessionId: string;
    trackIds: string;
    tagIds: string;
  }>({
    eventSessionId: StringParam,
    trackId: StringParam,
    tagIds: StringParam,
  });

  const { isOpen, onOpen, onClose } = useDisclosure();
  const hasActiveFilters = Boolean(trackIds || eventSessionId || tagIds);

  return (
    <Flex display={{ base: 'flex', lg: 'none' }} w="full" gap={3} align="center">
      <EventSearchInput w="full" isPoster={true} />
      <IconButton
        onClick={onOpen}
        size="sm"
        aria-label="Filters"
        variant="unstyled"
        flexShrink={0}
        color={hasActiveFilters ? 'violet.500' : 'black'}
        icon={<FunnelIcon style={{ margin: 'auto' }} />}
      />

      <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
        <DrawerOverlay />
        <DrawerContent p={{ base: 5, md: 10 }}>
          <Flex mb={{ base: 5, md: 10 }} alignItems="center" justifyContent="flex-end">
            <CloseButton onClick={onClose} />
          </Flex>
          <DrawerBody overflowY="hidden" p={0}>
            <Flex gap={4} flexDir="column">
              <ScheduleTrackFilter scope={TrackFilterScope.Posters} maxW="full" />
              <EventSessionsDropdown scope={SearchCategories.POSTERS} maxW="full" />
              <SessionTagFilter sessionPosterOnly="true" maxW="full" />
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </Flex>
  );
};
